module.exports = __webpack_public_path__ + "static/x100v-cardinal-zoom-71dc5c6b8ca3bfacb8ed1d48015498db.jpg";